import { ZodError } from 'zod';
import { getAssetUrl } from '../createAssetUrl';
import { AssetType } from '../types/enums';
import { Asset } from '../types/zod/assetSchema';
import { PatientCase, patientCaseSchema } from '../types/zod/patientCaseSchema';
import { captureSentry } from './sentryHelper';

export const parseCaseAssets = (caseContent: PatientCase): PatientCase => {
  const caseAssetsMap: { [assetId: string]: Asset } = {};

  caseContent.assets.forEach((asset) => {
    asset.url = getAssetUrl(caseContent.path, asset.path);

    switch (asset.type) {
      case AssetType.IMAGE:
        asset.thumbUrl = asset.url;
        break;
      case AssetType.VIDEO:
        asset.thumbUrl = getAssetUrl(caseContent.path, asset.thumbPath);
        break;
    }
    if (asset.thumbUrl.includes('mp4')) {
      console.warn(
        `WARN: (${caseContent.id}) Asset with "${asset.id}" has a thumb with .mp4 extension, please use .jpg`
      );
    }
    caseAssetsMap[asset.id] = { ...asset };
  });

  /*
  NOTE: validate if the case is well formatted
  */
  try {
    patientCaseSchema.parse(caseContent);
  } catch (err) {
    if (err instanceof ZodError) {
      captureSentry({
        title: 'PatientCase validation failed while fetching caseData',
        error: err,
        detail: {
          errorMessage: err.message,
          caseContent: caseContent,
        },
      });
      console.error(`PatientCase validation failed: ${caseContent.id} ${err}`);
    }
  }
  return caseContent;
};
